import { sendEventRegist } from 'helpers/analytics';
import { setError, setUserId } from 'store/actions/auth';

export const handleSuccessCreateAccount = (dispatch, res) => {
  if (![200, 201].includes(res.status)) return;
  const data = res?.data;
  const userId = data?.userDetail?.loginUserId;

  localStorage.setItem('phoneNo', userId);
  dispatch(setUserId(userId));
  sendEventRegist({
    action: 'User Successfully Input the OTP Register',
    label: 'OTP'
  });
  dispatch(setError(''));
};
